import { CheckCircle, HourglassEmpty, SwapHoriz } from "@mui/icons-material";

export const STATUS_THEME: any = {
  PAYABLE: { color: '#b45309', label: 'Payable', icon: <HourglassEmpty sx={{ fontSize: 14 }} /> },
  PAID_PRODUCER: { color: '#15803d', label: 'Paid Producer', icon: <CheckCircle sx={{ fontSize: 14 }} /> },
  PAID_OPERATOR: { color: '#0369a1', label: 'Paid Operator', icon: <SwapHoriz sx={{ fontSize: 14 }} /> },
};

export const ERROR_GLOSSARY: any = {
  BALANCE_ESCROW: "Insufficient funds on the Escrow wallet",
  BALANCE_PRODUCER: "Insufficient funds on the Producer wallet",
  MIRAKL: "Missing transactions from Mirakl",
  PRODUCER_STATUS: "Producer status is not VALIDATED",
  THRESHOLD_LIMIT: "Lemonway threshold limits reached",
  INT_32: "Amount too high for Lemonway typing. Manual payment required",
  LEMONWAY: "Issue from Lemonway",
  ONE_COMM: "Issue from OneComm"
};

export const formatPriceParts = (amount: number, currency: string) => {
  const formattedNumber = new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);

  const localeMap: Record<string, string> = {
    PLN: 'pl-PL', CZK: 'cs-CZ', HUF: 'hu-HU', EUR: 'fr-FR',
    GBP: 'en-GB', CHF: 'de-CH', RON: 'ro-RO'
  };

  const nativeString = new Intl.NumberFormat(localeMap[currency] || 'en-GB', {
    style: 'currency',
    currency: currency,
  }).format(0);

  const symbol = nativeString.replace(/[0-9.,\s\u00A0]/g, '');

  return { value: formattedNumber, symbol };
};

export const formatPrice = (amount: number, currency: string) => {
  const { value, symbol } = formatPriceParts(amount, currency);
  return `${value}\u00A0${symbol}`;
};


export const formatDate = (stringDate : string) => {
  const dates = stringDate.split('T')
  return dates[0] + ' / ' + dates[1] 
}